module.exports = __webpack_public_path__ + "img/icons_36.32646c10.png";